/**
 * authedFetch — 맨 fetch 를 쓰는 화면용 공용 호출 (2026-09-24)
 *
 * 액세스 토큰은 1시간이면 만료된다. 맨 fetch 로 부르는 화면은 그 뒤로 401 만 받고
 * 멈춰 있었다(사이드바 배지 · 순찰 QR 화면). 401 이 나면 공용 갱신(tokenManager)으로
 * 한 번 갱신하고 다시 부른다. 갱신 자체가 실패하면 처음 받은 401 응답을 그대로 돌려준다
 * — 로그아웃 판단은 tokenManager 가 한다(서버가 열쇠를 거절했을 때만).
 */
import { tokenManager } from './tokenManager';

export async function authedFetch(url: string, init: RequestInit = {}): Promise<Response> {
  const call = () => {
    const headers = new Headers(init.headers || {});
    const t = tokenManager.getAccessToken();
    if (t) headers.set('Authorization', `Bearer ${t}`);
    return fetch(url, { ...init, headers });
  };
  const res = await call();
  if (res.status !== 401 || !tokenManager.getRefreshToken()) return res;
  try {
    await tokenManager.refreshAccessToken();
  } catch {
    return res;
  }
  return call();
}
